import { render, staticRenderFns } from "./i4pro-list-email.vue?vue&type=template&id=5f93438f&scoped=true"
import script from "./i4pro-list-email.vue?vue&type=script&lang=js"
export * from "./i4pro-list-email.vue?vue&type=script&lang=js"
import style0 from "./i4pro-list-email.vue?vue&type=style&index=0&id=5f93438f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f93438f",
  null
  
)

export default component.exports